import * as types from 'modules/checklists/actionTypes';
import type { SetSelectedLocaleAction } from 'modules/checklists/types';
import { createReducer } from 'utils/ReduxUtils';

export type ChecklistUiDetailsSelectedLocaleReducer = string | null;

const initialState: ChecklistUiDetailsSelectedLocaleReducer = null;

const update = (
  _: ChecklistUiDetailsSelectedLocaleReducer,
  { payload: selectedLocale }: SetSelectedLocaleAction
): ChecklistUiDetailsSelectedLocaleReducer => selectedLocale;

const reset = (): ChecklistUiDetailsSelectedLocaleReducer => initialState;

export default createReducer(initialState, {
  [types.SET_IS_NEW]: reset,
  [types.SET_SELECTED_LOCALE]: update,
});
